import { useMutation } from '@tanstack/react-query';
import { notification } from 'antd';
import type { AxiosError } from 'axios';

import { axiosInstance } from '../../../axios/axiosInstance';
import type { PaymentPayload } from '../../model/interfaces/PaymentPayload';
import type { SubscriptionPayload } from '../../model/interfaces/SubscriptionPayload';

type CheckoutResponse = { redirect_url: string };

type ApiErrorBody = { message?: string };

export const useCheckOutPayment = (trigger: string | null = null) =>
  useMutation<CheckoutResponse, AxiosError<ApiErrorBody>, PaymentPayload | SubscriptionPayload>({
    mutationFn: async (payload) => {
      const { data } = await axiosInstance.post<CheckoutResponse>('api/payments/checkout', payload);
      return data;
    },
    onError: (err) => {
      if (trigger?.includes('email_offer')) return;

      const message = err.response?.data?.message;
      notification.error({ message: message ?? 'Purchase error!' });
    }
  });
